import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavigationBarMovilComponent } from 'projects/declarabid-private/src/app/shared/components/navigation-bar-movil/navigation-bar-movil.component';
import { NavigationBarComponent } from 'projects/declarabid-private/src/app/shared/components/navigation-bar/navigation-bar.component';

@Component({
  selector: 'app-declarant',
  imports: [RouterOutlet, NavigationBarComponent, NavigationBarMovilComponent],
  templateUrl: './declarant.component.html',
  styleUrl: './declarant.component.scss',
})
export class DeclarantComponent {}
